import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['ArtistManager']['getArtist']
type inputType = RouterInputs['ArtistManager']['getArtist']

export const useGetArtist = (input: inputType, options?: optionsType) =>
    api.ArtistManager.getArtist.useQuery(input, {
        ...options,
        queryKey: ['ArtistManager.getArtist', input],
        refetchOnWindowFocus: false,
        // TODO 15-минутный стейл тайм на время релиза
        staleTime: 15 * 60 * 1000 * staleTimeIndex, // 15 mins
    })
